module.exports = "pegasus/assets/theme4/medium/1.jpg";